
export enum ModuleExecutorDataExtractTypeCd {
	CONSTANT = 'Constant',
	PERIOD_CODE = 'PeriodCode'}

